<section class="agent-create-page">
  <header class="agent-create-page__header">
    <div class="agent-create-page__header-inner">
      <div class="agent-create-page__header-left">
        <button
          type="button"
          class="agent-create-page__back"
          (click)="navigateBack()"
          [attr.aria-label]="'agentCreate.header.back' | translate"
        >
          <mat-icon aria-hidden="true">arrow_back</mat-icon>
        </button>
        <div class="agent-create-page__header-text">
          <div class="agent-create-page__eyebrow">{{ 'agentCreate.header.eyebrow' | translate }}</div>
          <h1 class="agent-create-page__title">{{ 'agentCreate.header.title' | translate }}</h1>
        </div>
      </div>
      <div class="agent-create-page__header-actions">
        <button
          type="button"
          class="agent-create-page__cancel"
          data-testid="agent-create-cancel"
          (click)="navigateBack()"
        >
          {{ 'agentCreate.header.cancel' | translate }}
        </button>
        <button
          type="button"
          class="agent-create-page__save"
          data-testid="agent-create-submit"
          [disabled]="!canSubmit()"
          (click)="onSubmit()"
        >
          <mat-icon aria-hidden="true">check</mat-icon>
          <span>{{ 'agentCreate.submit' | translate }}</span>
        </button>
      </div>
    </div>
  </header>

  <div class="agent-create-page__body">
    <article class="agent-create-page__preview-card" aria-labelledby="agent-create-preview-title">
      <app-avatar [name]="previewName() || ('agentCreate.preview.fallbackName' | translate)" [size]="68" />
      <div class="agent-create-page__preview-text">
        <div class="agent-create-page__eyebrow">{{ 'agentCreate.preview.label' | translate }}</div>
        <div id="agent-create-preview-title" class="agent-create-page__preview-name">
          {{ previewName() || ('agentCreate.preview.fallbackName' | translate) }}
        </div>
        <div class="agent-create-page__preview-meta">
          <span class="agent-create-page__preview-email">
            {{ previewKuerzel() || ('agentCreate.preview.fallbackKuerzel' | translate) }}
          </span>
          <span class="agent-create-page__preview-dot" aria-hidden="true"></span>
          <app-ki-konto-pill />
          <span class="agent-create-page__preview-dot" aria-hidden="true"></span>
          <app-status-pill kind="aktiv" [label]="'agentCreate.status' | translate" size="sm" />
        </div>
      </div>
    </article>

    <form [formGroup]="form" (ngSubmit)="onSubmit()" novalidate>
      <section class="agent-create-page__panel" aria-labelledby="agent-create-section-title">
        <div class="agent-create-page__section-title">
          <h2 id="agent-create-section-title">{{ 'agentCreate.stammdaten.title' | translate }}</h2>
          <p>{{ 'agentCreate.stammdaten.subtitle' | translate }}</p>
        </div>

        <div class="agent-create-page__form-grid">
          <mat-form-field appearance="fill" class="agent-create-page__form-field">
            <mat-label>{{ 'agentCreate.stammdaten.firstNameLabel' | translate }}</mat-label>
            <input
              matInput
              data-testid="agent-first-name"
              formControlName="firstName"
              [attr.maxlength]="fieldLengths.FIRST_LAST_NAME_MAX"
              required
            />
            @if (form.controls.firstName.hasError('required')) {
              <mat-error>{{ 'agentCreate.stammdaten.firstNameRequired' | translate }}</mat-error>
            }
          </mat-form-field>

          <mat-form-field appearance="fill" class="agent-create-page__form-field">
            <mat-label>{{ 'agentCreate.stammdaten.lastNameLabel' | translate }}</mat-label>
            <input
              matInput
              data-testid="agent-last-name"
              formControlName="lastName"
              [attr.maxlength]="fieldLengths.FIRST_LAST_NAME_MAX"
              required
            />
            @if (form.controls.lastName.hasError('required')) {
              <mat-error>{{ 'agentCreate.stammdaten.lastNameRequired' | translate }}</mat-error>
            }
          </mat-form-field>

          <mat-form-field appearance="fill" class="agent-create-page__form-field agent-create-page__form-field--full">
            <mat-label>{{ 'agentCreate.stammdaten.kuerzelLabel' | translate }}</mat-label>
            <input
              matInput
              data-testid="agent-kuerzel"
              formControlName="kuerzel"
              autocomplete="off"
              [attr.maxlength]="fieldLengths.KUERZEL_MAX"
              required
            />
            <mat-hint>{{ 'agentCreate.stammdaten.kuerzelHint' | translate }}</mat-hint>
            @if (form.controls.kuerzel.invalid) {
              <mat-error data-testid="agent-kuerzel-error">
                @if (form.controls.kuerzel.hasError('taken')) {
                  {{ 'agentCreate.stammdaten.kuerzelTaken' | translate }}
                } @else if (form.controls.kuerzel.hasError('required')) {
                  {{ 'agentCreate.stammdaten.kuerzelRequired' | translate }}
                } @else {
                  {{ 'agentCreate.stammdaten.kuerzelInvalid' | translate }}
                }
              </mat-error>
            }
          </mat-form-field>
        </div>
      </section>
    </form>
  </div>
</section>
